// extracted by mini-css-extract-plugin
module.exports = {"bg":"fpH_T","inlineContent":"_1EZqI","pageWrapper":"_-19bi","root":"_327TB"};